import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { http, errMsg } from "@/lib/api";
import { useStore } from "@/context/StoreContext";
import { PageTitle } from "@/components/admin/AdminLayout";
import { MinecraftCard } from "@/components/admin/MinecraftCard";

const GROUPS = [
  { title: "Loja", fields: [["store_name", "Nome da loja"], ["server_address", "IP do servidor (mostrado na loja)"], ["announcement", "Aviso no topo do site"], ["hero_title", "Título principal"], ["hero_subtitle", "Subtítulo"], ["contact", "Contato (Discord, WhatsApp, e-mail...)"]] },
  { title: "Pix (Brasil)", accent: "text-emerald-300", fields: [["pix_key", "Chave Pix"], ["pix_name", "Nome do recebedor"], ["pix_city", "Cidade do recebedor"]] },
  { title: "MB Way (Portugal)", accent: "text-rose-300", fields: [["mbway_phone", "Número MB Way"], ["mbway_name", "Nome do titular"]] },
];

const PasswordCard = () => {
  const [f, setF] = useState({ current_password: "", new_password: "" });
  const submit = async (e) => {
    e.preventDefault();
    try { await http.post("/admin/change-password", f); toast.success("Senha alterada"); setF({ current_password: "", new_password: "" }); }
    catch (err) { toast.error(errMsg(err)); }
  };
  return (
    <form onSubmit={submit} className="rounded-2xl bg-[#111827] border border-white/10 p-6 space-y-4" data-testid="admin-password-form">
      <p className="font-heading font-bold">Alterar senha</p>
      <div className="grid sm:grid-cols-2 gap-4">
        <div className="space-y-2"><Label>Senha atual</Label><Input type="password" required value={f.current_password} onChange={(e) => setF({ ...f, current_password: e.target.value })} data-testid="admin-current-password-input" /></div>
        <div className="space-y-2"><Label>Nova senha (mín. 6)</Label><Input type="password" required minLength={6} value={f.new_password} onChange={(e) => setF({ ...f, new_password: e.target.value })} data-testid="admin-new-password-input" /></div>
      </div>
      <button className="h-10 px-5 rounded-full border border-white/15 hover:bg-white/10 text-sm font-semibold" data-testid="admin-change-password-button">Alterar senha</button>
    </form>
  );
};

export default function Settings() {
  const { refreshSettings } = useStore();
  const [s, setS] = useState(null);
  useEffect(() => { http.get("/admin/settings").then((r) => setS(r.data)); }, []);
  if (!s) return <p className="text-slate-500">Carregando...</p>;

  const save = async (e) => {
    e.preventDefault();
    try { await http.put("/admin/settings", s); toast.success("Configurações salvas"); refreshSettings(); }
    catch (err) { toast.error(errMsg(err)); }
  };

  return (
    <div className="max-w-3xl space-y-6">
      <PageTitle title="Configurações" sub="Dados da loja e onde você recebe os pagamentos" />
      <form onSubmit={save} className="space-y-6" data-testid="admin-settings-form">
        {GROUPS.map((g) => (
          <div key={g.title} className="rounded-2xl bg-[#111827] border border-white/10 p-6 space-y-4">
            <p className={`font-heading font-bold ${g.accent || ""}`}>{g.title}</p>
            <div className="grid sm:grid-cols-2 gap-4">
              {g.fields.map(([k, l]) => (
                <div key={k} className={`space-y-2 ${["announcement", "hero_subtitle"].includes(k) ? "sm:col-span-2" : ""}`}>
                  <Label>{l}</Label>
                  <Input value={s[k] || ""} onChange={(e) => setS({ ...s, [k]: e.target.value })} data-testid={`admin-settings-${k.replace(/_/g, "-")}-input`} />
                </div>
              ))}
            </div>
          </div>
        ))}
        <button className="h-11 px-7 rounded-full bg-violet-600 hover:bg-violet-500 font-semibold" data-testid="admin-settings-save-button">Salvar configurações</button>
      </form>
      <MinecraftCard />
      <PasswordCard />
    </div>
  );
}
